import { http } from '@/services/api'

export interface ProjectMirrorPayload {
  projectId: string
  userId: string
  meta: Record<string, unknown>
  project: Record<string, unknown>
}

export async function mirrorProject(payload: ProjectMirrorPayload, refreshToken: string): Promise<void> {
  await http.post('/project-mirror', payload, {
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  })
}
